// src/components/CourseTimeline.tsx
import React from 'react';
import './CourseTimeline.css';

interface Lesson {
  date: string;
  time: string;
  title: string;
  description: string;
}

const lessons: Lesson[] = [
  {
    date: 'Oct 18',
    time: '12:30-13:30 CET',
    title: 'Lesson 1',
    description: 'Lorem ipsum dolor sit amet consectetur. Diam elit aliquam senectus semper accumsan tortor scelerisque massa. Sagittis magna porta tristique ac leo a. Nulla sit tincidunt sociis suspendisse. Fermentum blandit velit at auctor.',
  },
  {
    date: 'Oct 19',
    time: '12:30-13:30 CET',
    title: 'Lesson 2',
    description: 'Lorem ipsum dolor sit amet consectetur. Diam elit aliquam senectus semper accumsan tortor scelerisque massa. Sagittis magna porta tristique ac leo a. Nulla sit tincidunt sociis suspendisse. Fermentum blandit velit at auctor.',
  },
  {
    date: 'Oct 19',
    time: '12:30-13:30 CET',
    title: 'Lesson 3',
    description: 'Lorem ipsum dolor sit amet consectetur. Diam elit aliquam senectus semper accumsan tortor scelerisque massa. Sagittis magna porta tristique ac leo a. Nulla sit tincidunt sociis suspendisse. Fermentum blandit velit at auctor.',
  },
];

const CourseTimeline: React.FC = () => {
  return (
    <div className="course-timeline">
      <h2 className="course-timeline-title">On Course</h2>
      <div className="timeline">
        {lessons.map((lesson, index) => (
          <div className="timeline-item" key={index}>
            <div className="timeline-date">
              <p className="date">{lesson.date}</p>
              <p className="time">{lesson.time}</p>
            </div>
            <div className="timeline-content">
              <h3 className="lesson-title">{lesson.title}</h3>
              <p className="lesson-description">{lesson.description}</p>
              <p className="lesson-button">learn More</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseTimeline;
